import { ScrollArea } from '@/components/shadcn/scroll-area'
import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import { SingleCard } from './SingleCard'
import { DataSchema, UISchema } from './types'
import clsx from 'clsx'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { getComponentHeights } from '../utils'
import { SearchInput } from '../shared/SearchInput'
import { useState } from 'react'

export function CardsContent({
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  uiSchema: UISchema
  dataSchema: DataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, layout, cards, emphasizeHeader, canSearch } = uiSchema
  const [search, setSearch] = useState('')
  const hasHeader = (!!title && !!tileFilters) || !!canSearch
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)

  const filteredCards = cards.filter((card) => {
    if (!canSearch) return true

    const query = search.trim().toLowerCase()
    if (!query) return true

    return (
      card.title?.toLowerCase().includes(query) ||
      card.description?.toLowerCase().includes(query)
    )
  })

  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>
            {canSearch && <SearchInput value={search} onChange={setSearch} />}
            {tileFilters}
          </ComponentActionsContainer>
        </ComponentHeader>
      )}
      <ScrollArea className={clsx({ 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        <div style={{ gridTemplateColumns: `repeat(${layout.columns}, minmax(0, 1fr))` }} className="grid gap-6 p-1">
          {filteredCards.map((card) => {
            const cardData = dataSchema.data.find((data) => data.id === card.id) || { id: card.id }
            return <SingleCard key={card.id} card={card} data={cardData} />
          })}
        </div>
      </ScrollArea>
    </div>
  )
}
